import { AppBar, Box, Toolbar, TextField, Modal, useTheme, Table, TableCell, TableBody, Checkbox, Tooltip, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider, useScrollTrigger, Slide, CssBaseline, Container, Grid, Card, CardContent } from "@mui/material";
import React, { useState, useEffect } from "react";

// icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Searchicon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";
import { tokens } from "../theme/theme";
import CustomTableContainer from "./CustomTableContainer";
import { useNavigate } from "react-router-dom";

import AmentApproveRequest from "./Ament-Approve-Request";
import AddNewRequestIndent from "../features/purchase/request-indent/AddRequestIndent";

const ViewAllRequests = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Request');
    const openFirst = Boolean(anchorElFirst);
    const [newVendor, setNewVendor] = useState(false);
    const [vendorHome, setVendorHome] = useState(true);

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [partyList, setPartyList] = useState([]);
    const [newRequestIndent, setNewRequestIndent] = useState(false);
    const [formID, setFormID] = useState(0);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openSecond = Boolean(anchorElSecond);

    const [documentNumber, setDocumentNumber] = useState(0);
    const [documentID, setDocumentID] = useState(0);
    const [departmentID, setDepartmentID] = useState(0);
    const [requesterID, setRequesterID] = useState(0);
    const [approverID, setApproverID] = useState(0);
    const [module, setModule] = useState('');
    const[requestID,setRequestID] = useState(0);
    const [cReason, setCReason] = useState('');


//pop-up
const [openChildRollList, setOpenChildRollList] = useState(false);

const closeChildRollList = () => {
    setOpenChildRollList(false);
    fetchAmentApprovalRequest();
};

// Handlers for first menu
const handleMenuClickFirst = (event) => {
    setAnchorElFirst(event.currentTarget);
};

const handleMenuCloseFirst = () => {
    setAnchorElFirst(null);
};

const handleMenuItemClickFirst = (option) => {
    setSelectedOptionFirst(option); // Update the selected option
    handleMenuCloseFirst();

    if (option === 'All Request') {
        setSelectedStatus('All');
    }
    else if (option === 'Active Request') {
        setSelectedStatus('Active');
    }
    else if (option === 'Inactive Request') {
        setSelectedStatus('InActive');
    }


    setAnchorElFirst(null);
};

// Handlers for second menu
const handleMenuClickSecond = (event) => {
    setAnchorElSecond(event.currentTarget);
};

const handleMenuCloseSecond = () => {
    setAnchorElSecond(null);
};

const handleMenuItemClickSecond = (option) => {
    handleMenuCloseSecond();
};

const handleShowNewVendor = () => {
    setEditPartyID(0);
    setVendorHome(false);
    setNewVendor(true);
}

const handlecallback = () => {
    setEditPartyID(0);
    setVendorHome(true);
    setNewVendor(false);
    setNewRequestIndent(false);
    fetchAmentApprovalRequest();
};


useEffect(() => {
    if (!isDataLoaded) {
        fetchAmentApprovalRequest();
    }
}, [isDataLoaded]);

const fetchAmentApprovalRequest = async () => {
    const para = {
        p_companyid: localStorage.getItem('companyid'),
        P_plantid: 1,
        p_user: localStorage.getItem('userID'),
        p_id_approved_by: localStorage.getItem('employeeID'),
        p_mode: 0,
    }

    callApi(API_ENDPOINTS.VIEW_ALL_REQUEST_APPROVAL_FOR_AMENT_PROCESS_BY_EMPLOYEE_ID, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
            if (data && data.length > 0) {
                setPartyList(data);
            }
        })
        .catch(error => {
            alert(error.message);
        });

}



const [open, setOpen] = useState(false);
const [filters, setFilters] = useState({
    name: '',
    companyname: '',
    email: '',
    workphone: '',
    status: '',
    payales: '',
});

const handleOpen = () => {
    setOpen(true);
};

const handleClose = () => {
    setOpen(false);
};

const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
};


const handleSelectAllClick = (event) => {
    if (event.target.checked) {
        const newSelectedRows = partyList.map((row) => row.id);
        setSelectedRows(newSelectedRows);
        return;
    }
    setSelectedRows([]);
};
const handleRowCheckboxClick = (event, rowId) => {
    const selectedIndex = selectedRows.indexOf(rowId);
    let newSelectedRows = [];

    if (selectedIndex === -1) {
        newSelectedRows = [...selectedRows, rowId];
    } else if (selectedIndex === 0) {
        newSelectedRows = selectedRows.slice(1);
    } else if (selectedIndex === selectedRows.length - 1) {
        newSelectedRows = selectedRows.slice(0, -1);
    } else if (selectedIndex > 0) {
        newSelectedRows = [
            ...selectedRows.slice(0, selectedIndex),
            ...selectedRows.slice(selectedIndex + 1),
        ];
    }

    setSelectedRows(newSelectedRows);


};

const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;


const [selectedRows, setSelectedRows] = useState([]);
const [showFirstToolbar, setShowFirstToolbar] = useState(true);
const [showNewToolbar, setShowNewToolbar] = useState(false);
const [selectedStatus, setSelectedStatus] = useState('All');

const filteredData = partyList.filter((row) => {
    // Check if row matches selected status
    if (selectedStatus === 'All' || row.status === selectedStatus) {
        // Check if all filter fields match
        return Object.keys(filters).every((key) => {
            if (filters[key] === '') return true; // No filter applied
            return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
        });
    }
    return false;
});

const [editPartyID, setEditPartyID] = useState(0)
const [selectedMode, setSelectedMode] = useState(0)

const handleCallEdit = (value, module) => {

    if (module === 'Request Indent') {
        setNewRequestIndent(true);
    }
    // 
    setEditPartyID(value);
    setVendorHome(false);
    setNewVendor(true);

};

const handleEdit = (document_number,document_id,department_id,requester_id,module,request_id,requested_to,reason) => {
    setDocumentNumber(document_number);
    setDocumentID(document_id);
    setDepartmentID(department_id);
    setRequesterID(requester_id);
    setModule(module);
    setRequestID(request_id);
    setApproverID(requested_to);
    setCReason(reason);
    setOpenChildRollList(true);
};

const handleDelete = () => {

};


return (
    <Box >
        <CssBaseline />
        {vendorHome && (

            <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                <Toolbar>
                    {/* First Menu */}
                    <Button
                        color="secondary"
                        onClick={handleMenuClickFirst}
                        endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                        sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                    >
                        {selectedOptionFirst}
                    </Button>
                    <Menu
                        anchorEl={anchorElFirst}
                        open={openFirst}
                        onClose={handleMenuCloseFirst}

                    >
                        <MenuItem onClick={() => handleMenuItemClickFirst('All Request')}>All Request</MenuItem>
                        <MenuItem onClick={() => handleMenuItemClickFirst('Active Request')}>Active Request</MenuItem>
                        <MenuItem onClick={() => handleMenuItemClickFirst('Inactive Request')}>Inactive Request</MenuItem>
                    </Menu>

                    {/* Adding margin-left: auto to push the button to the right */}
                    <Button size="small" variant="contained" disabled onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                    {/* Second Menu */}
                    <IconButton
                        size="small"
                        aria-label="menu"
                        sx={{ ml: 2 }}
                        onClick={handleMenuClickSecond}
                    >
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorElSecond}
                        open={openSecond}
                        onClose={handleMenuCloseSecond}
                    >
                        <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                            <ListItemIcon>
                                <ImportExportIcon />
                            </ListItemIcon>
                            <ListItemText primary="Import Vendors" />
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                            <ListItemIcon>
                                <FileDownloadIcon />
                            </ListItemIcon>
                            <ListItemText primary="Export Vendors" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                            <ListItemIcon>
                                <ViewColumnIcon />
                            </ListItemIcon>
                            <ListItemText primary="Export Current View" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                            <ListItemIcon>
                                <ListAltIcon />
                            </ListItemIcon>
                            <ListItemText primary="Preference " />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                            <ListItemIcon>
                                <RefreshIcon />
                            </ListItemIcon>
                            <ListItemText primary="Refresh List" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                            <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                Reset Columns Width
                            </Button>
                        </MenuItem>
                    </Menu>

                    <IconButton
                        size="small"
                        aria-label="menu"
                        sx={{ mr: 1, ml: 1 }}
                        onClick={handleMenuClickSecond}
                    >
                        <HelpIcon sx={{ fontSize: "18px" }} />
                    </IconButton>

                    <div>
                        <IconButton onClick={() => navigate("/")} >
                            <Close fontSize="inherit" sx={{ fontSize: "18px", color: "#2196F3" }} />
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>



        )}

        <AmentApproveRequest open={openChildRollList} handleBackWinderMachineEntry={closeChildRollList} onClose={closeChildRollList} documentNumber={documentNumber} documentID={documentID} departmentID={departmentID} requesterID={requesterID} module={module} mode={1} requestID={requestID} approverID={approverID} reason={cReason} />


        {vendorHome && (
            <CustomTableContainer colors={colors}>
                <TableContainer >
                    <Table size="small">
                        <TableHead sx={{ height: 10 }}>
                            <TableRow>
                                <TableCell>
                                    <Checkbox size="small" style={{ color: "secondary" }}
                                        indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                        checked={selectedRows.length === filteredData.length}
                                        onChange={handleSelectAllClick}
                                    />
                                </TableCell>
                                <TableCell>REQUEST FROM</TableCell>
                                <TableCell>DOCUMENT NO</TableCell>
                                <TableCell>DEPARTMENT</TableCell>
                                <TableCell>FORM NAME</TableCell>
                                <TableCell>REQUEST TO</TableCell>
                                <TableCell>REASON</TableCell>
                                <TableCell>STATUS</TableCell>

                                <TableCell>
                                    <IconButton onClick={handleOpen}>
                                        <Searchicon style={{ fontSize: "16px" }} />
                                    </IconButton>
                                    <Modal
                                        open={open}
                                        onClose={handleClose}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                    >
                                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                            <TextField
                                                label="NAME"
                                                name="name"
                                                value={filters.name}
                                                onChange={handleFilterChange}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                            />
                                            <TextField
                                                label="Company Name"
                                                name="companyName"
                                                value={filters.companyname}
                                                onChange={handleFilterChange}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                            />
                                            <TextField
                                                label="Email"
                                                name="email"
                                                value={filters.email}
                                                onChange={handleFilterChange}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                            />
                                            <TextField
                                                label="WorkPhone"
                                                name="workPhone"
                                                value={filters.workphone}
                                                onChange={handleFilterChange}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                            />
                                            <TextField
                                                label="Status"
                                                name="status"
                                                value={filters.status}
                                                onChange={handleFilterChange}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                            />
                                            <TextField
                                                label="Payables"
                                                name="payables"
                                                value={filters.payales}
                                                onChange={handleFilterChange}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                            />

                                            <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                Apply Filter
                                            </Button>
                                        </Box>
                                    </Modal>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.map((row) => (
                                <TableRow key={row.request_id}>
                                    <TableCell>
                                        <Checkbox
                                            size="small"
                                            checked={isSelected(row.request_id)}
                                            onChange={(event) => handleRowCheckboxClick(event, row.request_id)}
                                        />
                                        {['New Request'].includes(row.current_status) && (
                                            <>
                                                <Tooltip title="Edit">
                                                    <IconButton size="small" onClick={() => handleEdit(row.document_number,row.document_id,row.department_id,row.requester_id,row.module,row.request_id,row.requested_to,row.reason)}>
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                {/* <Tooltip title="Delete">
                                                        <IconButton size="small" onClick={() => handleDelete()}>
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip> */}
                                            </>
                                        )}
                                    </TableCell>

                                    <TableCell>{row.requested_by}</TableCell>
                                    <TableCell>
                                        <span
                                            style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                            onClick={() => handleCallEdit(row.document_id, row.module)}
                                        >
                                            {row.document_number}
                                        </span>
                                    </TableCell>
                                    <TableCell>{row.department}</TableCell>
                                    <TableCell>{row.module}</TableCell>
                                    <TableCell>{row.approved_by}</TableCell>
                                    <TableCell>{row.reason}</TableCell>
                                    <TableCell>{row.current_status}</TableCell>


                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CustomTableContainer>


        )}

        {newRequestIndent && (
            <>
                <AddNewRequestIndent handlecallback={handlecallback} editRequestIndentID={editPartyID} setEditRequestIndentID={setEditPartyID} selectedMode={0} setSelectedMode={setSelectedMode} formMode={0} />
            </>
        )}


    </Box>
)


}
export default ViewAllRequests;